import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"

import { Auth0Provider } from "@auth0/auth0-react"
import { ThemeProvider } from "styled-components"

const theme = {
  colors: {
    primary: "#B5A6F4",
  },
  revertColors: {
    primary: "#FFFFFF",
  },
}

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="samayahealth.eu.auth0.com"
      clientId="sKkPXd1Jj4OosuLREzSDVvTSicqJk8vI"
      redirectUri={window.location.origin}
    >
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
